import { put, takeEvery } from 'redux-saga/effects';
import { logOut as logOutAction, reset } from 'actions/user';
import { persistor } from 'store';
import { push } from 'connected-react-router';

export function* logOut() {
  yield put(reset());
  yield persistor.purge();
  yield persistor.persist();
  yield put(push('/signin'));
}

export default function* logOutSaga() {
  yield takeEvery(logOutAction, logOut);
}
